import { useEffect, useState } from 'react';

interface Props {
  text: string;
  onClose: () => void;
}

export default function TranslatePopup({ text, onClose }: Props) {
  const [translation, setTranslation] = useState<string | null>(null);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    const translate = async () => {
      try {
        const res = await fetch(
          `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=en&dt=t&q=${encodeURIComponent(text)}`
        );
        const data = await res.json();
        setTranslation(data[0]?.map((item: any) => item[0]).join('') || null);
      } catch {
        setTranslation(null);
      } finally {
        setFetching(false);
      }
    };
    translate();
  }, [text]);

  return (
    <>
      <div className="fixed inset-0 z-10" onClick={onClose} />
      <div className="fixed z-20 bottom-6 right-6 bg-zinc-900 border border-zinc-700 rounded-lg shadow-2xl w-72 max-h-64 flex flex-col">
        <div className="overflow-y-auto p-4">
          <p className="text-zinc-600 text-xs mb-2 line-clamp-2 leading-relaxed">{text}</p>
          {fetching ? (
            <div className="w-4 h-4 border-2 border-t-zinc-400 border-zinc-700 rounded-full animate-spin" />
          ) : translation ? (
            <p className="text-zinc-200 text-sm leading-relaxed">{translation}</p>
          ) : (
            <p className="text-zinc-600 text-sm">translation failed</p>
          )}
        </div>
      </div>
    </>
  );
}
